import { PaletteMode, PaletteOptions } from '@mui/material';
import { GetThemeOptions } from '../theme';
import { unitySemanticDarkColorTokens, unitySemanticLightColorTokens } from '../unityTokens';

export const checkbox = (mode: PaletteMode, opts: GetThemeOptions): PaletteOptions['checkbox'] => {
  if (!opts.panwRebrandStubYear) {
    return undefined;
  }

  const tokens = mode === 'light' ? unitySemanticLightColorTokens : unitySemanticDarkColorTokens;
  return {
    checkedColor: tokens['--semantic-bg-input-inverse'],
    checkedHoverColor: tokens['--semantic-bg-input-inverse-hover'],
    uncheckedBorderColor: tokens['--semantic-border-bold'],
    uncheckedHoverBorderColor: tokens['--semantic-border-inverse'],
    disabledColor: tokens['--semantic-text-disabled'],
  };
};
